import React, {Component} from "react"

class ScreenBlocker extends Component {
    render() {
        return (
            <div>
                <div style={{left: "0", zIndex: "1031"}} className="dark-overlay"></div>
            </div>

        )
    }
}

export default ScreenBlocker